import React from "react";
import CricketMatchHead from "../../football/match/CricketMatchHead";
import CricketInfoTable from "../../cricket/CricketInfoTable";
import LiveScoreCard from "../../cricket/LiveScoreCard";
import CricketStandings from "../../cricket/CricketStandings";
import CricketScorecardTable from "../../cricket/CricketScorecardTable";
import CricketFallOfWickets from "../../cricket/CricketFallOfWickets";
import CricketTeamTable from "../../cricket/CricketTeamTable";
import CricketCommentaryWrap from "../../cricket/CricketCommentaryWrap";

const CricketMatchWidgetWrap = (props) => {
  const {
    dataId,
    dataType,
    head,
    data,
    headData,
    sport,
    difference,
    loadCSS,
    dataClient,
    websiteBaseUrl,
    dataPath,
    dataTitle,
    baseUrl,
    show_cricket_animation = 0,
    socketUrl = "",
    channel = "CricketMatch",
    event = `CricketMatchDetails`
  } = props;

  const renderHeadWrap = (currentTab, children) =>
    head ? (
      <CricketMatchHead
        matchDetail={headData}
        difference={difference}
        sport={sport}
        dataClient={dataClient}
        id={dataId}
        currentTab={currentTab}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        title={dataTitle}
        show_cricket_animation={show_cricket_animation}
        socketUrl={socketUrl}
        channel={channel}
        event={event + `-${dataId}`}
      >
        {children}
      </CricketMatchHead>
    ) : (
      children
    );

  switch (dataType) {
    case "cricket-match-info":
      return renderHeadWrap("info",
        <CricketInfoTable
          ServerData={data?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          difference={difference}
          title={dataTitle}
        />
      );

    case "cricket-match-live":
      return renderHeadWrap("live",
        <LiveScoreCard
          ServerData={data?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          difference={difference}
          title={dataTitle}
          socketUrl={socketUrl}
          matchId={dataId}
        />
      );

    case "cricket-match-standings":
      return renderHeadWrap("standings",
        <CricketStandings
          ServerData={data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          difference={difference}
          title={dataTitle}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
        />
      );

    case "cricket-match-scorecard":
      return renderHeadWrap("scorecard",
        <CricketScorecardTable
          ServerData={data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          difference={difference}
          title={dataTitle}
          socketUrl={socketUrl}
          matchId={dataId}

        />
      );

    case "cricket-match-wickets":
      return renderHeadWrap("fall_of_wickets",
        <CricketFallOfWickets
          ServerData={data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          difference={difference}
          title={dataTitle}
        />
      );

    case "cricket-match-teams":
      return renderHeadWrap("teams",
        <CricketTeamTable
          ServerData={data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          difference={difference}
          title={dataTitle}
        />
      );

    case "cricket-match-com":
      return renderHeadWrap("commentary",
        <CricketCommentaryWrap
          ServerData={data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          difference={difference}
          title={dataTitle}
          matchId={dataId}
          baseUrl={baseUrl}
        />
      );

    case "cricket-match":
      return (head && (<CricketMatchHead
        matchDetail={headData}
        difference={difference}
        sport={sport}
        dataClient={dataClient}
        id={dataId}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        title={dataTitle}
      />))

    default:
      return <h1>Cricket Match Widget Not Found!</h1>;
  }
};

export default CricketMatchWidgetWrap;
